import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PowercheckerStateService {

    public stateChange: Subject<boolean> = new Subject<boolean>();

    constructor() {
    }

}
